import { useRemoteQuery } from "../../useRemote/useRemoteQuery";

export type UserLocationAdminLocation = {
  locationInventoryId: number;
  name: string;
};

export function useRemoteFetchUserLocationAdminLocations(enabled: boolean) {
  return useRemoteQuery<UserLocationAdminLocation[] | null>({
    queryKey: ["userLocationAdminLocations"],
    url: "/user-info/user-location-admin-locations",
    enabled
  });
}
